import Repository from '../repository';

const resource = '/area';

export default {
  getProvinces() {
    return Repository.get(`${resource}/provinces`);
  },
  getAmphures(params) {
    return Repository.get(`${resource}/amphures`, { params });
  },
  getDistricts(params) {
    return Repository.get(`${resource}/districts`, { params });
  },
};
